import request from '../request/index'

/**
 * 获取充值模版
 */
export function getTemplate() {
  return request({
    url: '/order/getTemplate',
    method: 'post'
  })
}

/**
 * 创建充值订单
 * template_type	string	必须 countDown\coins\vip	
 * template_index	number	必须 模版类型为coins时需要	
 * template_md5	string	必须   充值模版字符串的md5
 */
export function createOrder(data) {
  return request({
    url: '/order/createTemplateOrder',
    method: 'post',
    data
  })
}

/**
 *  获取订单状态
 *    入参:
 *      order_code--string--充值 订单号
 *    出参: http://yapi.yunxiacn.com:3000/project/136/interface/api/10402
 *
 */
export function getOrderStatus(data) {
  return request({
    url: '/order/get/status',
    method: 'POST',
    data
  })
}

/**
 * 获取促销弹窗信息
 */
export function getPromotionInfo() {
  return request({
    url: '/order/getPromotion',
    method: 'POST'
  })
}

/**
 * 创建促销订单
 */
export function createPromotion() {
  return request({
    url: '/order/createPromotion',
    method: 'POST'
  })
}
